export const PHONE_REGEX = /^[0-9-+()]*$/;
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const MATCH_ALPHABETIC = /^[a-zA-Z].*/;